import React from 'react';

import { RATIO_16x9, WIDTH_1024, WIDTH_640,  } from '../../../util/imageUtils';
import ShapeFixer from './ShapeFixer';
import Sizer from './Sizer';
import Thumbnail from './Thumbnail';

import './scss/FixedPoster.scss';

const FixedPoster = (props) => {
	const className = props.className,
		ratio = props.card_ratio|| props.ratio || RATIO_16x9,
		{ inDetailsCard = false, filloutRatio = false } = props,
		sizeKeys = props.sizeKeys || {},
		pcWidth = sizeKeys.pc || WIDTH_1024,
		mobileWidth = sizeKeys.mobile || WIDTH_640;

	return (<React.Fragment>
		<div className={`fixed-poster${filloutRatio ? ' fill-out' : ''}`}>
			<ShapeFixer ratio={filloutRatio || ratio} />
			<Thumbnail
				className={`poster-img-wrp${inDetailsCard ? ' align-right' : ''} ${className ? className : ''}`}
				thumbnails={props.thumbnails || {}}
				ratio={ratio}
				maxWidth={props.mobileWidth ? mobileWidth : pcWidth}
				title={props.title}
			/>
			{filloutRatio ? <div className={`fill-tint${inDetailsCard ? ' left-tint' : ''} `}></div> : ''}
		</div>
	</React.Fragment>);
};

export default Sizer(FixedPoster);
